import {GET_FILTER_LIST} from './actionTypes'

const initialState = {
  choice: 'schedule',
  // isLoading: false,
  // hasError: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTER_LIST:
      return {
        ...state,
        choice: action.payload,
      }

    default:
      return state
  }
};
